export const MOCK_BATTERY_CHARGE = [
  { hh: 7, data: 0 },
  { hh: 8, data: 15 },
  { hh: 9, data: 35 },
  { hh: 10, data: 55 },
  { hh: 11, data: 75 },
  { hh: 12, data: 90 },
  { hh: 13, data: 100 },  // 최대치
  { hh: 14, data: 85 },
  { hh: 15, data: 65 },
  { hh: 16, data: 45 },
  { hh: 17, data: 25 },
  { hh: 18, data: 10 },
  { hh: 19, data: 0 },   // 완전 소모
];

export const MOCK_BATTERY_DISCHARGE = [
  { hh: 19, data: -5 },
  { hh: 20, data: -10 },
  { hh: 21, data: -15 },
  { hh: 22, data: -20 },
  { hh: 23, data: -25 },
  { hh: 0, data: -30 },
  { hh: 1, data: -25 },
  { hh: 2, data: -20 },
  { hh: 3, data: -15 },
  { hh: 4, data: -10 },
  { hh: 5, data: -5 },
  { hh: 6, data: -3 },
  { hh: 7, data: -1 },
  { hh: 8, data: 0 },
];

export const MOCK_DEMAND = [
  { hh: 1, data: 22 },
  { hh: 2, data: 28 },
  { hh: 3, data: 35 },
  { hh: 4, data: 42 },
  { hh: 5, data: 55 },
  { hh: 6, data: 62 },
  { hh: 7, data: 75 },
  { hh: 8, data: 83 },
  { hh: 9, data: 95 },
  { hh: 10, data: 98 },
  { hh: 11, data: 107 },
  { hh: 12, data: 112 },
  { hh: 13, data: 110 }, // Peak
  { hh: 14, data: 104 },
  { hh: 15, data: 96 },
  { hh: 16, data: 87 },
  { hh: 17, data: 78 },
  { hh: 18, data: 69 },
  { hh: 19, data: 58 },
  { hh: 20, data: 47 },
  { hh: 21, data: 39 },
  { hh: 22, data: 30 },
  { hh: 23, data: 24 },
  { hh: 0, data: 20 },
];

export const MOCK_SOLAR_PREDICTION = [
  { hh: 7, data: 0 },
  { hh: 8, data: 15 },
  { hh: 9, data: 32 },
  { hh: 10, data: 50 },
  { hh: 11, data: 68 },
  { hh: 12, data: 85 },
  { hh: 13, data: 130 }, // 최고점
  { hh: 14, data: 110 },
  { hh: 15, data: 90 },
  { hh: 16, data: 70 },
  { hh: 17, data: 50 },
  { hh: 18, data: 30 },
  { hh: 19, data: 0 },
];

export const MOCK_SOLAR = [
  { hh: 7, data: 0 },
  { hh: 8, data: 12 },
  { hh: 9, data: 38 },
  { hh: 10, data: 58 },
  { hh: 11, data: 83 },
  { hh: 12, data: 110 },
  { hh: 13, data: 120 }, // 최고점
  { hh: 14, data: 100 },
  { hh: 15, data: 82 },
  { hh: 16, data: 65 },
  { hh: 17, data: 48 },
  { hh: 18, data: 30 },
  { hh: 19, data: 0 }, // 최저점
];


export function filterRecentData(data) {
  if (!data) return [];
  const currentHour = new Date().getHours();
  const startHour = (currentHour - 12 + 24) % 24; // 현재 시간 - 12시간 (음수 방지)

  return data.filter(entry =>
    startHour <= currentHour
      ? entry.hh >= startHour && entry.hh <= currentHour  // 일반적인 경우 (예: 5~17)
      : entry.hh >= startHour || entry.hh <= currentHour  // 날짜가 넘어가는 경우 (예: 23~11)
  );
}


export function getMockBatteryCharge() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(filterRecentData(MOCK_BATTERY_CHARGE));
    }, 1000);
  });
}

export function getMockBatteryDischarge() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(filterRecentData(MOCK_BATTERY_DISCHARGE));
    }, 1000);
  });
}

export function getMockDemand() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(filterRecentData(MOCK_DEMAND));
    }, 1000);
  });
}

export function getMockSolarPrediction() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(filterRecentData(MOCK_SOLAR_PREDICTION));
    }, 1000);
  });
}

export function getMockSolar() {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(filterRecentData(MOCK_SOLAR));
    }, 1000);
  });
}
